(() => {
  if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.availabilityFilterPatched) return;

  const availabilityParam = 'filter.v.availability';
  const variantOptionPrefix = 'filter.v.option.';
  const variantCountCache = new Map();
  let countRequestId = 0;
  let countAbortController;
  let initialCountsRequested = false;

  const hasVariantOptionFilter = (searchParams) => {
    const params = searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams(searchParams);
    return Array.from(params.keys()).some((key) => key.startsWith(variantOptionPrefix));
  };

  const normalizeSearchParams = (searchParams) => {
    const params = new URLSearchParams(searchParams);

    if (hasVariantOptionFilter(params)) {
      params.set(availabilityParam, '1');
    } else {
      params.delete(availabilityParam);
    }

    return params.toString();
  };

  const hideAvailabilityFilter = (root = document) => {
    root.querySelectorAll(`input[name="${availabilityParam}"]`).forEach((input) => {
      const filterElement = input.closest('.js-filter');
      if (filterElement) filterElement.hidden = true;
    });

    const currentParams = new URLSearchParams(window.location.search);
    if (!currentParams.has(availabilityParam)) return;

    root.querySelectorAll('facet-remove .active-facets__button--light').forEach((button) => {
      const buttonParams = new URL(button.href, window.location.origin).searchParams;
      if (!buttonParams.has(availabilityParam)) {
        const activeFacet = button.closest('facet-remove');
        if (activeFacet) activeFacet.hidden = true;
      }
    });
  };

  const applyAvailabilityAwareVariantCounts = (html) => {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    parsedHTML.querySelectorAll('.js-filter').forEach((sourceFilter) => {
      if (!sourceFilter.querySelector(`input[name^="${variantOptionPrefix}"]`)) return;

      const targetFilter = document.getElementById(sourceFilter.id);
      if (!targetFilter) return;

      const sourceValues = sourceFilter.querySelector('.facets-wrap, .mobile-facets__list');
      const targetValues = targetFilter.querySelector('.facets-wrap, .mobile-facets__list');

      if (sourceValues && targetValues) targetValues.replaceWith(sourceValues.cloneNode(true));
    });

    hideAvailabilityFilter();
  };

  const updateAvailabilityAwareVariantCounts = (searchParams) => {
    const params = new URLSearchParams(searchParams);
    if (hasVariantOptionFilter(params)) {
      countRequestId += 1;
      countAbortController?.abort();
      return;
    }

    const productGrid = document.getElementById('product-grid');
    const sectionId = productGrid?.dataset.id;
    if (!sectionId) return;

    params.delete('section_id');
    params.delete('page');
    params.set(availabilityParam, '1');
    params.set('section_id', sectionId);

    const cacheKey = `${window.location.pathname}?${params.toString()}`;
    const cachedHTML = variantCountCache.get(cacheKey);
    if (cachedHTML) {
      applyAvailabilityAwareVariantCounts(cachedHTML);
      return;
    }

    const requestId = ++countRequestId;
    countAbortController?.abort();
    countAbortController = new AbortController();

    fetch(cacheKey, { signal: countAbortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error(`Variant count request failed with status ${response.status}`);
        return response.text();
      })
      .then((html) => {
        if (requestId !== countRequestId) return;
        variantCountCache.set(cacheKey, html);
        applyAvailabilityAwareVariantCounts(html);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.warn('Could not refresh availability-aware variant counts.', error);
      });
  };

  const requestInitialVariantCounts = () => {
    if (initialCountsRequested) return;
    initialCountsRequested = true;
    updateAvailabilityAwareVariantCounts(FacetFiltersForm.searchParamsPrev);
  };

  const originalRenderPage = FacetFiltersForm.renderPage.bind(FacetFiltersForm);
  FacetFiltersForm.renderPage = (searchParams, event, updateURLHash = true) =>
    originalRenderPage(normalizeSearchParams(searchParams), event, updateURLHash);

  const originalRenderFilters = FacetFiltersForm.renderFilters.bind(FacetFiltersForm);
  FacetFiltersForm.renderFilters = (html, event) => {
    const result = originalRenderFilters(html, event);
    hideAvailabilityFilter();
    initialCountsRequested = true;
    updateAvailabilityAwareVariantCounts(FacetFiltersForm.searchParamsPrev);
    return result;
  };

  FacetFiltersForm.availabilityFilterPatched = true;
  FacetFiltersForm.normalizeAvailabilitySearchParams = normalizeSearchParams;
  FacetFiltersForm.updateAvailabilityAwareVariantCounts = updateAvailabilityAwareVariantCounts;

  const currentSearchParams = window.location.search.slice(1);
  const normalizedSearchParams = normalizeSearchParams(currentSearchParams);

  FacetFiltersForm.searchParamsInitial = normalizedSearchParams;
  FacetFiltersForm.searchParamsPrev = currentSearchParams;
  hideAvailabilityFilter();

  if (normalizedSearchParams !== currentSearchParams) {
    initialCountsRequested = true;
    history.replaceState(
      { searchParams: normalizedSearchParams },
      '',
      `${window.location.pathname}${normalizedSearchParams && '?'.concat(normalizedSearchParams)}${window.location.hash}`,
    );
    FacetFiltersForm.renderPage(normalizedSearchParams, null, false);
  } else {
    const filters = document.getElementById('main-collection-filters');
    filters?.addEventListener('pointerdown', requestInitialVariantCounts, { once: true, passive: true });
    filters?.addEventListener('focusin', requestInitialVariantCounts, { once: true });
  }
})();
